import callApi from './backendService';

const basePath = `/frontend/api/one-to-one/${process.env.VUE_APP_COMPANY_KEY}/profile`;

export const changeProfilePicture = (formData) => callApi({
    method: 'POST',
    headers: {
        'Content-Type': 'multipart/form-data'
    },
    endpoint: `${basePath}/change-profile-picture`,
    body: formData
  });
